import { render, staticRenderFns } from "./appraisaQuestionBankDetail.vue?vue&type=template&id=5ed102b2"
import script from "./appraisaQuestionBankDetail.vue?vue&type=script&lang=js"
export * from "./appraisaQuestionBankDetail.vue?vue&type=script&lang=js"
import style0 from "./appraisaQuestionBankDetail.vue?vue&type=style&index=0&id=5ed102b2&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports